
import { defineComponent, ref, useContext } from '@nuxtjs/composition-api'

export default defineComponent({
  name: 'IndexWeddingringsByColor',
  props: {
    pageStr: {
      type: String,
      required: true,
    },
  },
  setup(props) {
    const {
      app: { i18n },
    } = useContext()

    const weddingringsColor = ref([
      {
        text: i18n.t(props.pageStr + '.element_weddingrings_by_color.platinum'),
        alt:
          i18n.t(props.pageStr + '.element_weddingrings_by_color.platinum') +
          ' - A-2130-1',
        image: 'color_platinum_a-2130-1',
        link: 'weddingRingsPlatinum',
      },
      {
        text: i18n.t(
          props.pageStr + '.element_weddingrings_by_color.yellowgold'
        ),
        alt:
          i18n.t(props.pageStr + '.element_weddingrings_by_color.yellowgold') +
          ' - A-2230-1',
        image: 'color_gold_a-2230-1',
        link: 'weddingRingsGold',
      },
      {
        text: i18n.t(
          props.pageStr + '.element_weddingrings_by_color.whitegold'
        ),
        alt:
          i18n.t(props.pageStr + '.element_weddingrings_by_color.whitegold') +
          ' - A-1939-8',
        image: 'color_whitegold_a-1939-8',
        link: 'weddingRingsWhitegold',
      },
      {
        text: i18n.t(
          props.pageStr + '.element_weddingrings_by_color.signature'
        ),
        alt:
          i18n.t(props.pageStr + '.element_weddingrings_by_color.signature') +
          ' - A-1598-6',
        image: 'color_signature_a-1598-6',
        link: 'weddingRingsSignature',
      },
      {
        text: i18n.t(props.pageStr + '.element_weddingrings_by_color.rosegold'),
        alt:
          i18n.t(props.pageStr + '.element_weddingrings_by_color.rosegold') +
          ' - A-1755-1',
        image: 'color_rosegold_a-1755-1',
        link: 'weddingRingsRosegold',
      },
      {
        text: i18n.t(props.pageStr + '.element_weddingrings_by_color.redgold'),
        alt:
          i18n.t(props.pageStr + '.element_weddingrings_by_color.redgold') +
          ' - A-2111-1',
        image: 'color_redgold_a-2111-1',
        link: 'weddingRingsRedgold',
      },
      {
        text: i18n.t(
          props.pageStr + '.element_weddingrings_by_color.multicolor'
        ),
        alt:
          i18n.t(props.pageStr + '.element_weddingrings_by_color.multicolor') +
          ' - A-2230-1',
        image: 'color_multicolor_a-1629-3',
        link: 'weddingRingsTwoColors',
      },
    ])

    return {
      weddingringsColor,
    }
  },
})
